import { render, staticRenderFns } from "./userTypeCell.vue?vue&type=template&id=0887b99f&scoped=true"
import script from "./userTypeCell.vue?vue&type=script&lang=js"
export * from "./userTypeCell.vue?vue&type=script&lang=js"
import style0 from "./userTypeCell.vue?vue&type=style&index=0&id=0887b99f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887b99f",
  null
  
)

export default component.exports